import { PenLine } from "lucide-react";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useDashboardWidget } from "@/lib/hooks/use-dashboard";
import { useT } from "@/lib/i18n/use-t";
import { useDashboardFormat } from "../use-dashboard-format";
import { KeyFigureValue } from "./key-figure-value";
import { T } from "./pending-signatures-widget.i18n";
import { StatsCard } from "./stats-card";

/** Today's Pending Signatures figure, unchanged. */
export function PendingSignaturesWidget({ target }: { target: DashboardTarget }) {
  const { data, isLoading, error } = useDashboardWidget("pending_signatures", target);
  const t = useT(T);
  const { count } = useDashboardFormat();
  return (
    <StatsCard
      icon={PenLine}
      label={t.pendingSignatures}
      value={
        <KeyFigureValue isLoading={isLoading} error={error}>
          {data && count(data.pending)}
        </KeyFigureValue>
      }
      subtitle={data && t.signedTotal(count(data.signed))}
    />
  );
}
